
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";

export interface EmployerFormData {
  organization: string;
  companySize: string;
  industry: string;
  companyDescription: string;
}

interface EmployerSignupFieldsProps {
  data: EmployerFormData;
  onChange: (data: Partial<EmployerFormData>) => void;
  className?: string;
}

export const EmployerSignupFields = ({ data, onChange, className = "" }: EmployerSignupFieldsProps) => {
  return (
    <div className={`space-y-4 ${className}`}>
      <div className="space-y-2">
        <Label htmlFor="organization">Organization Name *</Label>
        <Input 
          id="organization"
          value={data.organization}
          onChange={(e) => onChange({ organization: e.target.value })}
          placeholder="Enter your company name"
          className="bg-background text-foreground"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="companySize">Company Size</Label>
        <Select 
          value={data.companySize} 
          onValueChange={(value) => onChange({ companySize: value })}
        >
          <SelectTrigger className="bg-background text-foreground">
            <SelectValue placeholder="Select company size" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1-10">1-10 employees</SelectItem>
            <SelectItem value="11-50">11-50 employees</SelectItem>
            <SelectItem value="51-200">51-200 employees</SelectItem>
            <SelectItem value="201-500">201-500 employees</SelectItem>
            <SelectItem value="501-1000">501-1000 employees</SelectItem>
            <SelectItem value="1001+">1001+ employees</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="industry">Industry</Label>
        <Select 
          value={data.industry} 
          onValueChange={(value) => onChange({ industry: value })}
        >
          <SelectTrigger className="bg-background text-foreground">
            <SelectValue placeholder="Select industry" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Technology">Technology</SelectItem>
            <SelectItem value="Finance">Finance</SelectItem>
            <SelectItem value="Healthcare">Healthcare</SelectItem>
            <SelectItem value="Education">Education</SelectItem>
            <SelectItem value="Manufacturing">Manufacturing</SelectItem>
            <SelectItem value="Retail">Retail</SelectItem>
            <SelectItem value="Services">Services</SelectItem>
            <SelectItem value="Other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="companyDescription">Company Description (Optional)</Label>
        <Textarea
          id="companyDescription"
          value={data.companyDescription}
          onChange={(e) => onChange({ companyDescription: e.target.value })}
          placeholder="Briefly describe your company"
          className="h-24 bg-background text-foreground resize-none"
        />
      </div>
    </div>
  );
};
